'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateImageFile = exports.VALIDATION_CODES = undefined;

var _fileUploadConstants = require('../../../../common/utils/fileUploadConstants');

var VALIDATION_CODES = exports.VALIDATION_CODES = {
    MAX_SIZE: 'MAX_SIZE',
    INVALID_TYPE: 'INVALID_TYPE'
};

/**
 * Validates whether a file passed in is an image and is within the size limits expected.
 *
 * @param file {File} The DOM File object to validate.
 * @returns {Object} null if the file is valid, otherwise an object with error codes and details.
 */
var validateImageFile = exports.validateImageFile = function validateImageFile(file) {
    // The file type must match the expected mime pattern
    if (!file.type || !file.type.match(_fileUploadConstants.FILE_TYPES.IMAGE.mimePattern)) {
        var message = 'Sorry, this file type is not supported';
        console.warn(message);
        return {
            error: true,
            code: VALIDATION_CODES.INVALID_TYPE,
            message: message,
            explanation: 'You can upload PNGs, JPEGs and GIFs',
            details: {
                type: _fileUploadConstants.FILE_TYPES.IMAGE.name,
                expected: 'image/*',
                actual: file.type
            }
        };
    }

    // Ensure the file is within the allowed limits
    if (file.size > _fileUploadConstants.FILE_TYPES.IMAGE.maxSize) {
        var _message = 'Sorry, this image is too large';
        console.warn(_message);
        return {
            error: true,
            code: VALIDATION_CODES.MAX_SIZE,
            message: _message,
            explanation: 'The maximum supported file size is 10MB',
            details: {
                type: _fileUploadConstants.FILE_TYPES.IMAGE.name,
                max: _fileUploadConstants.FILE_TYPES.IMAGE.max_size,
                actual: file.size
            }
        };
    }

    // successful validation will not return an object
    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/file/fileValidator.js
// module id = 238
// module chunks = 0